var _rect, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFormStatus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 234 234"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "form-status_svg__currentLayer"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.538 131.8h-148c-2.8 0-5-2.2-5-5v-20.3c0-2.8 2.2-5 5-5h148c2.8 0 5 2.2 5 5v20.3c0 2.7-2.2 5-5 5zM228.538 64.8h-148c-2.8 0-5-2.2-5-5V39.5c0-2.8 2.2-5 5-5h148c2.8 0 5 2.2 5 5v20.3c0 2.8-2.2 5-5 5zM228.538 199.5h-148c-2.8 0-5-2.2-5-5v-20.3c0-2.8 2.2-5 5-5h148c2.8 0 5 2.2 5 5v20.3c0 2.8-2.2 5-5 5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M40.338 139.6l-33.4-33.4c-1.9-1.9-1.9-5.1 0-7.1l4.7-4.7c1.9-1.9 5.1-1.9 7.1 0l33.4 33.4c1.9 1.9 1.9 5.1 0 7.1l-4.7 4.7c-1.9 1.9-5.1 1.9-7.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.138 106.2l-33.4 33.4c-1.9 1.9-5.1 1.9-7.1 0l-4.7-4.7c-1.9-1.9-1.9-5.1 0-7.1l33.4-33.4c1.9-1.9 5.1-1.9 7.1 0l4.7 4.7c2 1.9 2 5.1 0 7.1zM18.838 72.6l-16.8-16.8c-1.9-1.9-1.9-5.1 0-7.1l4.5-4.5c1.9-1.9 5.1-1.9 7.1 0l16.8 16.8c1.9 1.9 1.9 5.1 0 7.1l-4.5 4.5c-2 1.9-5.1 1.9-7.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.138 39.2l-33.4 33.4c-1.9 1.9-5.1 1.9-7.1 0l-4.7-4.7c-1.9-1.9-1.9-5.1 0-7.1l33.4-33.4c1.9-1.9 5.1-1.9 7.1 0l4.7 4.7c2 1.9 2 5.1 0 7.1zM18.838 206.6l-16.8-16.8c-1.9-1.9-1.9-5.1 0-7.1l4.5-4.5c1.9-1.9 5.1-1.9 7.1 0l16.8 16.8c1.9 1.9 1.9 5.1 0 7.1l-4.5 4.5c-2 1.9-5.1 1.9-7.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.138 173.2l-33.4 33.4c-1.9 1.9-5.1 1.9-7.1 0l-4.7-4.7c-1.9-1.9-1.9-5.1 0-7.1l33.4-33.4c1.9-1.9 5.1-1.9 7.1 0l4.7 4.7c2 1.9 2 5.1 0 7.1z"
  })))));
}

export default SvgFormStatus;